/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import slices from '../../state/slices/data';

export default function Header() {
  const options = useSelector((state) => state.data.options);
  const dispatch = useDispatch();
  const { setId } = slices.actions;

  function handleSelectChange(selectedOption) {
    dispatch(setId(selectedOption.value));
  }

  const id = useSelector((state) => state.data.id);
  const selectValue =
    options.length > 0 ? options.find((option) => option.value === id) : null;

  return (
    <header>
      <h1 className="headline">Select your occupation</h1>
      <p>
        Average weekly earnings before tax for all employees including full-time
        and part-time staff, as well as chief executives and managing directors.
        Figures also include paid overtime.
      </p>
      <Select
        className="select"
        options={options}
        onChange={handleSelectChange}
        value={selectValue}
      />
    </header>
  );
}
